<div #carousel class="media-carousel carousel">
    <div #innerCarouselContainer class="carousel-inner">
        @for (pImage of loadedImages; track pImage.path) {
            <div
                media-image
                [imageUrl]="pImage.path"
                [imageModel]="imageModel"
                (imageLoaded)="onImageLoad($event)"
                (imageError)="onImageError($event)"
            ></div>
        }
    </div>
</div>
